import type SweepOptionType from '../store/schema/SweepOptionType';
import sweepStore from '../store/store';
import { mutatorAction } from 'satcheljs';

/**
 * Set the SweepOptionType in sweep store
 * @param key the key as SweepOptionType to set
 * @param state the state which contains the sweep store
 */
const setSweepOptionTypeMutator: (key: SweepOptionType) => void = mutatorAction(
    'setSweepOptionType',
    function setSweepOptionType(key: SweepOptionType): void {
        sweepStore().sweepOptionType = key;
    }
);
export default setSweepOptionTypeMutator;
